import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { formatIDR } from "@/lib/format";
import { ChevronLeft, Copy, Tag } from "lucide-react";
import { toast } from "sonner";

export default function StoreVouchers() {
  const nav = useNavigate();
  const [items, setItems] = useState(null);

  useEffect(() => { api.get("/vouchers").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);

  return (
    <div className="space-y-3 animate-fade-up">
      <div className="flex items-center justify-between">
        <button onClick={() => nav(-1)} className="w-9 h-9 rounded-full bg-white border border-blush-soft flex items-center justify-center">
          <ChevronLeft className="w-5 h-5" />
        </button>
        <h1 className="font-semibold">Voucher Saya</h1>
        <div className="w-9" />
      </div>

      {items === null && <div className="text-center py-10 text-sm text-cocoa-muted">Memuat...</div>}
      {items !== null && items.length === 0 && (
        <div className="text-center py-14 bg-white rounded-2xl border border-blush-soft">
          <Tag className="w-10 h-10 text-cocoa-muted mx-auto mb-2" />
          <div className="text-sm text-cocoa-muted">Belum ada voucher aktif saat ini.</div>
        </div>
      )}
      {items?.map((v) => (
        <div key={v.id} data-testid={`voucher-card-${v.code}`} className="bg-gradient-to-br from-[#C4707F] to-[#A85B6A] rounded-2xl p-4 text-white relative overflow-hidden">
          <div className="absolute -right-4 -bottom-4 w-20 h-20 rounded-full bg-white/10" />
          <div className="flex justify-between items-start">
            <div>
              <div className="text-3xl font-bold">{v.percent}%<span className="text-base font-semibold"> OFF</span></div>
              <div className="text-xs opacity-90 mt-0.5">{v.title}</div>
              <div className="text-[10px] opacity-80 mt-1">Min. belanja {formatIDR(v.min_purchase)} • Maks. potongan {formatIDR(v.max_discount)}</div>
              <div className="text-[10px] opacity-80">Berlaku s.d. {v.valid_until}</div>
            </div>
          </div>
          <div className="flex items-center justify-between mt-3 bg-white/15 rounded-xl px-3 py-2">
            <span className="font-mono text-sm font-bold tracking-wider">{v.code}</span>
            <button
              data-testid={`voucher-copy-${v.code}`}
              onClick={() => { navigator.clipboard?.writeText(v.code); toast.success(`Kode ${v.code} disalin`); }}
              className="flex items-center gap-1 text-xs font-semibold bg-white text-brand rounded-full px-3 py-1.5"
            >
              <Copy className="w-3 h-3" /> Salin
            </button>
          </div>
        </div>
      ))}
      <div className="text-center text-[11px] text-cocoa-muted pt-2">Pakai kode di halaman checkout sebelum bayar.</div>
    </div>
  );
}
